import axios from 'axios';
import { l } from 'src/utils';

// Функция для расчета задержки на основе последовательности Фибоначчи
function fibonacciDelay(attempt) {
  const fib = (n) => (n <= 1 ? n : fib(n - 1) + fib(n - 2));
  return fib(attempt) * 1000 + Math.random() * 1000; // Задержка в миллисекундах
}

const BASE_URL = process.env.VUE_APP_BACKEND || 'http://localhost:3000';

// Создаем экземпляр Axios
const axiosInstance = axios.create({
  baseURL: BASE_URL,
  timeout: 10000, // Таймаут для запросов (10 секунд)
});

// Максимальное количество попыток повторов
const MAX_RETRIES = 5;

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const { config, response } = error;
    if (!config || !config.retry) {
      config.retry = 0;
    }
    // Пропускаем повтор запроса для определенных кодов ошибок
    if (response && (response.status === 401 || response.status === 403)) {
      l.error(`Request failed with status ${response.status}. No retry.`);
      return Promise.reject(error);
    }

    // Проверяем, нужно ли повторить запрос
    if (config.retry < MAX_RETRIES) {
      config.retry += 1; // Увеличиваем счетчик попыток
      const delay = fibonacciDelay(config.retry);
      l.warn(
        `Retry attempt #${config.retry} for ${config.url}, delay: ${Math.round(delay)}ms`,
      );

      await new Promise((resolve) => setTimeout(resolve, delay));
      return axiosInstance(config);
    }
    l.error(
      `Request failed after ${MAX_RETRIES} retries: ${config.url}`,
    );
    return Promise.reject(error);
  },
);

export default axiosInstance;
